var exports = {
  "JC": "Accordion.module__accordion___Y1JHZV",
  "U1": "Accordion.module__headerRow___Y1JHZV",
  "L9": "Accordion.module__headerClickTarget___Y1JHZV",
  "N4": "Accordion.module__titleButton___Y1JHZV",
  "Z2": "Accordion.module__descriptionButton___Y1JHZV",
  "me": "Accordion.module__caretButton___Y1JHZV",
  "VW": "Accordion.module__headerContent___Y1JHZV",
  "$": "Accordion.module__titleRow___Y1JHZV",
  "QE": "Accordion.module__headerAction___Y1JHZV",
  "ID": "Accordion.module__compactTitle___Y1JHZV",
  "SY": "Accordion.module__compactDescription___Y1JHZV",
  "OW": "Accordion.module__caret___Y1JHZV",
  "bd": "Accordion.module__caretExpanded___Y1JHZV",
  "FG": "Accordion.module__contentWrapper___Y1JHZV",
  "Qs": "Accordion.module__content___Y1JHZV",
};

module.exports = exports;
